<template>
<ul class="nav nav-tabs">
    <li class="active"><a href="#tab_1_1" data-toggle="tab"  @click="sendType('simple')"> Simple </a></li>
    <li class=""><a href="#tab_1_2" data-toggle="tab"  @click="sendType('photo')"> Photos </a></li>
    <li class=""><a href="#tab_1_3" data-toggle="tab"  @click="sendType('video')"> Video </a></li>
</ul>
</template>

<script>
export default {

  name: 'blogNav',
  props: {
    type: {
      type: String,
      required: true,
      default: null
    }
  },
  methods: {
    sendType (type) {
      this.$emit('update:type', type)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
